import { commonColors } from "./data";

export const generateDataForGraph = (resultRx: any, fields: any, lang?: string) => {
  const { field1, field2c, field6b, field2b, field2a, field6a } = fields;

  let verticalAxisData = [];
  const colors = [];
  const greenColorValues = [];
  const verticalAxisLabel = [];
  const verticalAxisLabelGreen = [];

  const getGValue = (k, rx) => {
    const u = k / rx;

    const e = (u * Number(fields?.field7)) / 1000;
    const g = (e * Number(fields?.field8) * 60) / 1000;

    return Number(g.toFixed(3));
  };

  for (let i = 1; i < Number(field1) + 1; i++) {
    for (let j = 0; j < resultRx.length; j++) {
      // FOR FIRST BARS AT THE TOP WHEN THERE IS THREE COLUMNS

      if (i === 1 && field2c && field2c.length > 0) {
        if (
          (Number(field1) === 3 && field6a.split(" - ")[0] === "3" && j > resultRx.length - 4) ||
          (field6a.split(" - ")[2] === "4" && j > resultRx.length - 5) ||
          (field6a.split(" - ")[2] === "2" && j > resultRx.length - 3) ||
          (field6a.split(" - ")[2] === "1" && j > resultRx.length - 2)
        ) {
          const gValue = getGValue(Number(field2c), Number(resultRx[j]));
          const label = `${Number(resultRx[j])} * ${Number(field2c)}`;

          verticalAxisLabel.push(label);
          verticalAxisData.push(gValue);
          colors.push(commonColors["red"]);
        } else {
          const gValue = getGValue(Number(field2c), Number(resultRx[j]));
          const label = `${Number(resultRx[j])} * ${Number(field2c)}`;

          verticalAxisLabel.push(label);
          verticalAxisData.push(gValue);
          greenColorValues.push(gValue);
          verticalAxisLabelGreen.push(label);
          colors.push(commonColors["green"]);
        }
      }

      // FOR FIRST BARS AT THE TOP WHEN THERE IS TWO COLUMNS
      if (i === 1 && (!field2c || field2c?.length === 0)) {
        if (
          Number(field1) === 2 &&
          ((field6b.split(" - ")[1] === "1" && j > resultRx.length - 2) ||
            (field6b.split(" - ")[1] === "2" && j > resultRx.length - 3) ||
            (field6b.split(" - ")[1] === "3" && j > resultRx.length - 4) ||
            (field6b.split(" - ")[1] === "4" && j > resultRx.length - 5))
        ) {
          const gValue = getGValue(Number(field2b), Number(resultRx[j]));
          const label = `${Number(resultRx[j])} * ${Number(field2b)}`;

          verticalAxisLabel.push(label);
          verticalAxisData.push(gValue);
          colors.push(commonColors["red"]);
        } else {
          if (field2b && field2b.length > 0) {
            const gValue = getGValue(Number(field2b), Number(resultRx[j]));
            const label = `${Number(resultRx[j])} * ${Number(field2b)}`;

            verticalAxisLabel.push(label);
            verticalAxisData.push(gValue);
            greenColorValues.push(gValue);
            verticalAxisLabelGreen.push(label);
            colors.push(commonColors["green"]);
          } else {
            const gValue = getGValue(Number(field2a), Number(resultRx[j]));
            const label = `${Number(resultRx[j])} * ${Number(field2a)}`;

            verticalAxisLabel.push(label);
            verticalAxisData.push(gValue);
            greenColorValues.push(gValue);
            verticalAxisLabelGreen.push(label);
            colors.push(commonColors["green"]);
          }
        }
      }

      // FOR SECOND BARS FROM THE TOP

      if (i === 2) {
        // FOR SECOND BARS FROM THE TOP WHEN THERE IS THREE COLUMNS

        if (field2c) {
          if (
            (Number(field1) === 3 && field6a.split(" - ")[1] === "2" && (j < 1 || j > resultRx.length - 2)) ||
            (field6a.split(" - ")[1] === "4" && (j < 2 || j > resultRx.length - 3))
          ) {
            const gValue = getGValue(Number(field2b), Number(resultRx[j]));
            const label = `${Number(resultRx[j])} * ${Number(field2b)}`;

            verticalAxisLabel.push(label);
            verticalAxisData.push(gValue);
            colors.push(commonColors["red"]);
          } else {
            const gValue = getGValue(Number(field2b), Number(resultRx[j]));
            const label = `${Number(resultRx[j])} * ${Number(field2b)}`;

            verticalAxisLabel.push(label);
            verticalAxisData.push(gValue);
            greenColorValues.push(gValue);
            verticalAxisLabelGreen.push(label);
            colors.push(commonColors["green"]);
          }
        } else {
          if (
            (Number(field1) === 2 && field6b.split(" - ")[0] === "1" && j < 1) ||
            (field6b.split(" - ")[0] === "2" && j < 2) ||
            (field6b.split(" - ")[0] === "3" && j < 3) ||
            (field6b.split(" - ")[0] === "4" && j < 4)
          ) {
            const gValue = getGValue(Number(field2a), Number(resultRx[j]));
            const label = `${Number(resultRx[j])} * ${Number(field2a)}`;

            verticalAxisLabel.push(label);
            verticalAxisData.push(gValue);
            colors.push(commonColors["red"]);
          } else {
            const label = `${Number(resultRx[j])} * ${Number(field2a)}`;
            const gValue = getGValue(Number(field2a), Number(resultRx[j]));

            verticalAxisData.push(gValue);
            verticalAxisLabel.push(label);

            greenColorValues.push(gValue);
            verticalAxisLabelGreen.push(label);
            colors.push(commonColors["green"]);
          }
        }
      }

      // FOR THIRD BARS FROM THE TOP

      if (i === 3) {
        if (
          Number(field1) === 3 &&
          ((field6a.split(" - ")[0] === "1" && j < 1) ||
            (field6a.split(" - ")[0] === "2" && j < 2) ||
            (field6a.split(" - ")[0] === "3" && j < 3) ||
            (field6a.split(" - ")[0] === "4" && j < 4))
        ) {
          const gValue = getGValue(Number(field2a), Number(resultRx[j]));
          const label = `${Number(resultRx[j])} * ${Number(field2a)}`;

          verticalAxisLabel.push(label);
          verticalAxisData.push(gValue);
          colors.push(commonColors["red"]);
        } else if (Number(field1) === 3 && field6a === "1 - 0 - 1" && j === 0) {
          const gValue = getGValue(Number(field2a), Number(resultRx[j]));
          const label = `${Number(resultRx[j])} * ${Number(field2a)}`;

          verticalAxisLabel.push(label);
          verticalAxisData.push(gValue);
          colors.push(commonColors["red"]);
        } else {
          const gValue = getGValue(Number(field2a), Number(resultRx[j]));
          const label = `${Number(resultRx[j])} * ${Number(field2a)}`;

          verticalAxisLabel.push(label);
          verticalAxisData.push(gValue);

          greenColorValues.push(gValue);
          verticalAxisLabelGreen.push(label);
          colors.push(commonColors["green"]);
        }
      }
    }
  }

  return { verticalAxisData, colors, greenColorValues, verticalAxisLabel, verticalAxisLabelGreen };
};

export const hasUserFilledAllFields = (fields: any): boolean => {
  const { field1, field2a, field2b, field2c, field3, field3a, field3b, field6a, field6b, field7, field8 } = fields;
  if (
    !field1 ||
    field1?.length === 0 ||
    ((!field2a || field2a?.length === 0) &&
      (!field2b || field2b?.length === 0) &&
      (!field2c || field2c?.length === 0)) ||
    !field3 ||
    ((field3?.length === 0 || !field3a || field3a?.length === 0) && (!field3b || field3b?.length === 0)) ||
    ((!field6a || field6a?.length === 0) && (!field6b || field6b?.length === 0)) ||
    !field7 ||
    field7?.length === 0 ||
    !field8 ||
    field8?.length === 0
  ) {
    return false;
  } else {
    return true;
  }
};
